import { InputSearchPro } from 'components/InputSearch';

const fieldsInfo = {};

const tabs = [
  {
    title: null,
    fields: [
      'clave',
      'folio_interno',
      'folio',
      'nombre_ciudadano',
      'nombre_contribuyente',
      'fecha_de_multa',
      'hora_multa',
      'unidad_responsable',
      'usuario_inspector',
      'identificacion',
      'numero_permiso',
      'zona',
      'sector',
      'cuadro',
      'tipo_de_obra',
      'clase_de_multa',
      'detalle_general',
      'datos_multa',
    ],
  },
];

const configs = {
  clave: {
    formItemProps: {
      label: 'Clave',
      required: true,
    },
  },
  folio_interno: {
    formItemProps: {
      label: 'Folio Interno',
      required: true,
    },
  },
  folio: {
    formItemProps: {
      label: 'Folio',
    },
  },
  nombre_ciudadano: {
    formItemProps: {
      label: 'Nombre Ciudadano',
    },
  },
  nombre_contribuyente: {
    formItemProps: {
      label: 'Nombre Contribuyente',
    },
  },
  fecha_de_multa: {
    formItemProps: {
      label: 'Fecha Multa',
    },
  },
  hora_multa: {
    formItemProps: {
      label: 'Hora Multa',
    },
  },
  unidad_responsable: {
    formItemProps: {
      label: 'Unidad responsable',
    },
  },
  usuario_inspector: {
    advanced: true,
    control: InputSearchPro,
    label: 'Inspector',
    tooltip: 'Búsqueda por correo electrónico del Inpsector',
    resultProps: {
      name: 'usuario_inspector',
      label: 'Inspector',
      labelProp: 'nombre_completo',
    },
    qName: 'email',
    rules: [{ required: true }],
  },
  identificacion: {
    formItemProps: {
      label: 'Identificación',
    },
  },
  numero_permiso: {
    formItemProps: {
      label: 'Número de Permiso',
    },
  },
  zona: {
    formItemProps: {
      label: 'Zona',
    },
  },
  sector: {
    formItemProps: {
      label: 'Sector de Infraccion',
    },
  },
  cuadro: {
    formItemProps: {
      label: 'Cuadro',
    },
  },
  tipo_de_obra: {
    formItemProps: {
      label: 'Tipo de Obra',
    },
  },
  clase_de_multa: {
    formItemProps: {
      label: 'Clase de Multa',
    },
    rules: [{ required: true }],
  },
  detalle_general: {
    formItemProps: {
      label: 'Detalle General',
    },
    colProps: { span: 24 },
  },
  datos_multa: {
    formItemProps: {
      label: 'Datos Multa',
    },
    colProps: { span: 24 },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
